import http from '@axios'
import paramsConverter from './utils/paramsConverter'

const resource = '/api/v1/school'

export default {
  list(params = {}) {
    const paramsString = paramsConverter(params)

    return http.get(`${resource}${paramsString}`)
  },
  add(school) {
    return http.post(`${resource}`, school)
  },
  get(uuid) {
    return http.get(`${resource}/${uuid}`)
  },
  update(school, uuid) {
    return http.post(`${resource}/${uuid}?_method=PATCH`, school, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },
  destroy(uuid) {
    return http.delete(`${resource}/${uuid}`)
  },
}
